(function () {
  angular
    .module('specsguardApp')
    .factory('sgAutocompleteHelpers', sgAutocompleteHelpers);

  function sgAutocompleteHelpers () {
    function sortOptions (items, nonAlphabetical, optionsMapping) {
      if (nonAlphabetical) {
        return items;
      } else if (!optionsMapping) {
        return items.sort((a, b) => a - b);
      }
      return items.sort((a, b) => {
        let key = optionsMapping.displayNameKey;
        if (angular.isArray(optionsMapping.displayNameKey)) {
          key = optionsMapping.displayNameKey[optionsMapping.displayNameKey.length - 1];
        }

        const aLower = a[key].toLowerCase();
        const bLower = b[key].toLowerCase();
        if (aLower < bLower) {
          return -1;
        } else if (aLower > bLower) {
          return 1;
        }
        return 0;
      });
    }

    const createFilterQueryFor = (str, displayKey) => {
      let key = displayKey;
      if (angular.isArray(displayKey)) {
        key = displayKey[displayKey.length - 1];
      }
      const lowerCase = str.toLowerCase();
      return (item) => {
        const itemValue = key ? item[key].toString() : item.toString();
        return itemValue.toLowerCase().includes(lowerCase);
      };
    };

    // filter takes the this.fieldsObj[key] as argument.
    // options is destructured, and thus equals this.fieldsObj[key].options
    // This arguments is sweetened with some new key/values in both the controller and by sg-autocomplete
    const filter = ({options, searchValue, searchTextChanged, nonAlphabetical, optionsMapping}) => {
      if (!searchValue || !searchTextChanged) {
        return sortOptions(options, nonAlphabetical, optionsMapping);
      }

      const filteredItems = options.filter(createFilterQueryFor(searchValue, optionsMapping.displayNameKey));
      return sortOptions(filteredItems, nonAlphabetical, optionsMapping);
    };

    return {
      filter: filter,
      sortOptions: sortOptions,
    };
  }
})();
